// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';

let limit = config.limit.default;

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getPlacesError = error => {
  return {
    type: constants.GET_PLACES_ERROR,
    error,
  };
};

const getPlacesSuccess = places => {
  return {
    type: constants.GET_PLACES_SUCCESS,
    places: places,
  };
};

const getPlaceError = error => {
  return {
    type: constants.GET_PLACE_ERROR,
    error,
  };
};

const getPlaceSuccess = place => {
  return {
    type: constants.GET_PLACE_SUCCESS,
    place: place,
  };
};

const postPlaceError = error => {
  return {
    type: constants.POST_PLACE_ERROR,
    error,
  };
};

const postPlaceSuccess = place => {
  return {
    type: constants.POST_PLACE_SUCCESS,
    place: place,
  };
};

const patchPlaceError = error => {
  return {
    type: constants.PATCH_PLACE_ERROR,
    error,
  };
};

const patchPlaceSuccess = place => {
  return {
    type: constants.PATCH_PLACE_SUCCESS,
    place: place,
  };
};

const getPlaces = filterParams => {
  let apiURL = `${experienceAPIURL}/places?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
  }
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getPlacesError(response.statusText));
        }
        dispatch(getPlacesSuccess(response.data));
      })
      .catch(error => {
        dispatch(getPlacesError(error));
      });
  };
};

const getPlace = id => {
  let apiURL = `${experienceAPIURL}/places/${id}`;

  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getPlaceError(response.statusText));
        }
        dispatch(getPlaceSuccess(response.data));
      })
      .catch(error => {
        dispatch(getPlaceError(error));
      });
  };
};

const postPlace = newPlace => {
  let apiURL = `${experienceAPIURL}/places`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: newPlace };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postPlaceError(response.statusText));
        }
        dispatch(postPlaceSuccess(response.data));
      })
      .catch(error => {
        dispatch(postPlaceError(error));
      });
  };
};

const patchPlace = place => {
  let apiURL = `${experienceAPIURL}/places/${place.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: place };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchPlaceError(response.statusText));
        }
        dispatch(patchPlaceSuccess(response.data));
      })
      .catch(error => {
        dispatch(patchPlaceError(error));
      });
  };
};

export { getPlaces, getPlace, postPlace, patchPlace };
